import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';
import { createCardField } from './utils';

export const CardExpiry = createCardField<StripeCardExpiryElementChangeEvent>({
  ElementComponent: CardExpiryElement,
  elementKind: 'cardExpiry',
  label: 'Expiration',
  wrapperClassName: 'gap-sm w-full',
});
